import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import { Delimeter } from 'components/elements/delimeter';
import IconCross from 'components/icons/cross';
import Modal from 'components/modal/modal';

import LABELS from './keys';
import { Body, CloseButton, PanelTitle } from './styles';
import { TitanModalButtons, TitanModalMessage } from './titanModalComponents';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
};

export const TitanModal = ({ isOpen, onClose, onAccept, onDecline }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Panel
        label={<PanelTitle>{t(LABELS.MODAL_TITLE)}</PanelTitle>}
        controls={
          <CloseButton flat onClick={onClose}>
            <IconCross />
          </CloseButton>
        }
      >
        <Body>
          <TitanModalMessage />
          <Delimeter />
          <TitanModalButtons onAccept={onAccept} onDecline={onDecline} />
        </Body>
      </Panel>
    </Modal>
  );
};
